/** Avenham Park, Preston, UK */
export const MAP_DEFAULT_CENTER = { lat: 53.7520, lng: -2.6986 };
